import { create } from "zustand";
import type { Message } from "@/types/chat";

interface ChatStore {
  messages: Message[];
  input: string;
  isLoading: boolean;
  streamingMessageId: string | undefined;
  page: number;
  hasMore: boolean;
  isLoadingHistory: boolean;

  setMessages: (messages: Message[] | ((prev: Message[]) => Message[])) => void;
  setInput: (input: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  setStreamingMessageId: (id: string | undefined) => void;
  setPage: (page: number) => void;
  setHasMore: (hasMore: boolean) => void;
  setIsLoadingHistory: (isLoading: boolean) => void;
  reset: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  input: "",
  isLoading: false,
  streamingMessageId: undefined,
  page: 1,
  hasMore: true,
  isLoadingHistory: false,

  setMessages: (messages) =>
    set((state) => ({
      messages:
        typeof messages === "function" ? messages(state.messages) : messages,
    })),
  setInput: (input) => set({ input }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setStreamingMessageId: (streamingMessageId) => set({ streamingMessageId }),
  setPage: (page) => set({ page }),
  setHasMore: (hasMore) => set({ hasMore }),
  setIsLoadingHistory: (isLoadingHistory) => set({ isLoadingHistory }),
  reset: () =>
    set({
      messages: [],
      input: "",
      isLoading: false,
      streamingMessageId: undefined,
      page: 1,
      hasMore: true,
      isLoadingHistory: false,
    }),
}));
